import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { register } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Enable PWA install + auto-updates (production only)
register({
  onUpdate: (registration) => {
    // Simple update UX for now (we can make a nice toast later)
    const ok = window.confirm("A new version is available. Update now?");
    if (!ok) return;

    if (registration?.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  },
});

reportWebVitals();